import React, { Component } from "react";

import _ from "lodash";

import List from "components/list/List";
import Pagination from "components/pagination/Pagination";
import { Button } from "antd";
class CommercialList extends Component {
  componentDidMount() {
    this.props.init();
  }

  render() {
    const { commercialList, page, pages, pageSize, nbItems, getNext, openModalForCreation } = this.props;
    const columns = this.props.columns.map(column => {
      let newColumn = {
        title: column.title,
        dataIndex: column.key,
        key: column.key
      };
      if (column.sortable) {
        newColumn.onHeaderCell = () => {
          return {
            onClick: () => {
              const currentSortOrder = this.state.sortOrder;
              let nextSortOrder;
              if (currentSortOrder === 0) {
                nextSortOrder = -1;
              } else if (currentSortOrder === -1) {
                nextSortOrder = 1;
              } else {
                nextSortOrder = 0;
              }

              this.setState({ sortOrder: nextSortOrder }, () => {
                this.props.setSort(column.key, nextSortOrder);
              });
            }
          };
        };

        newColumn.sortOrder = null;
      }
      if (column.render) {
        newColumn.render = column.render;
      }
      return newColumn;
    });
    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Périodes commerciales</h2>
        </div>
        <Button onClick={openModalForCreation}>CREER UNE PERIODE COMMERICALE</Button>
        <div class="p-content-page-center-content">
          <List
            columns={columns}
            data={!_.isEmpty(commercialList) ? commercialList : []}
            page={page}
            pages={pages}
            defaultText="Aucune période commerciale trouvée."
          />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default CommercialList;



// WEBPACK FOOTER //
// src/containers/admin/CommercialList.js